// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"D6tfx","player":"OmAmp"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewsBlock/Video.scss
 ** module id = 104
 ** module chunks = 0
 **/